import React from 'react';
import { Box, Typography, Paper, Container, Button } from '@mui/material';
import { Construction as ConstructionIcon, Mail as MailIcon } from '@mui/icons-material';

const AdvertisersPage: React.FC = () => {
  return (
    <Container maxWidth="lg" sx={{ mt: 4, mb: 4 }}>
      <Box sx={{ mb: 4 }}>
        <Typography variant="h4" component="h1" gutterBottom sx={{ fontWeight: 500 }}>
          Advertisers
        </Typography>
        <Typography variant="body1" color="text.secondary">
          Connect with advertisers and manage your advertising relationships.
        </Typography>
      </Box>
      
      <Paper 
        sx={{ 
          p: 6, 
          mb: 4, 
          display: 'flex', 
          flexDirection: 'column', 
          alignItems: 'center',
          textAlign: 'center'
        }}
      >
        <ConstructionIcon sx={{ fontSize: 80, color: 'warning.main', mb: 3 }} />
        
        <Typography variant="h5" component="h2" gutterBottom>
          This Section is Under Construction
        </Typography>
        
        <Typography variant="body1" color="text.secondary" sx={{ maxWidth: 600, mb: 4 }}>
          We're working hard to build out our advertisers platform. This section will soon allow you to manage advertiser relationships, track campaigns, and optimize ad performance.
        </Typography>
        
        <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
          Expected release: November 2025
        </Typography>
        
        <Button 
          variant="contained" 
          color="primary" 
          startIcon={<MailIcon />}
          href="mailto:support@locationstation.com?subject=Advertisers%20Platform%20Inquiry"
        >
          Contact Us For Updates
        </Button>
      </Paper>
    </Container>
  );
};

export default AdvertisersPage;